import { render } from "./TablaColectivosFamilias.vue?vue&type=template&id=86923a2c&ts=true"
import script from "./TablaColectivosFamilias.vue?vue&type=script&lang=ts"
export * from "./TablaColectivosFamilias.vue?vue&type=script&lang=ts"

import "./TablaColectivosFamilias.vue?vue&type=style&index=0&id=86923a2c&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__